import { Modifier, ModifierGroup, Product } from '@eo-storefronts/eo-core'
import { useProductAvailable } from '~/src/hooks/products/useProductAvailable'
import { useEoValue } from '~/src/hooks/useEoState'
import CartModifierGroupStateService from '~/src/services/CartModifierGroupStateService'
import { CART_MODIFIER_GROUP_STATE, CartModifierGroupStateInterface } from '~/src/stores/cart'
import { CHECKOUT_TIME_STATE } from '~/src/stores/checkout'
import { MODIFIER_GROUPS_STATE } from '~/src/stores/modifier-groups'
import { MODIFIERS_STATE } from '~/src/stores/modifiers'

interface ReturnsType {
  isAddToCartButtonEnabled(): boolean,
}

const useAddToCartButtonStatus = (product: Product): ReturnsType => {
  const modifierGroups = useEoValue<Record<string, ModifierGroup>>(MODIFIER_GROUPS_STATE)
  const modifiers = useEoValue<Record<string, Modifier>>(MODIFIERS_STATE)
  const checkoutTime = useEoValue(CHECKOUT_TIME_STATE)
  const cartModifierGroups = useEoValue<CartModifierGroupStateInterface[]>(CART_MODIFIER_GROUP_STATE)
  const { available: productAvailable } = useProductAvailable(product)
  const service = new CartModifierGroupStateService(
    cartModifierGroups,
    modifierGroups,
    modifiers,
    checkoutTime
  )

  const isAddToCartButtonEnabled = (): boolean => {
    if (!productAvailable) {
      return false
    }

    return service.validateGroups(cartModifierGroups, product.modifierGroups)
  }

  return {
    isAddToCartButtonEnabled
  }
}

export {
  useAddToCartButtonStatus
}
